import Axios from "../config/config";

//Pre Email Template

export const LIST_PREDEFINE_TEMPLATE= async (body) => {
    try {
        const response = await Axios.post('list-predefine-template/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const ADD_PREDEFINE_TEMPLATE= async (body) => {
    try {
        const response = await Axios.post('add-predefine-template/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};
export const EDIT_PREDEFINE_TEMPLATE= async (body) => {
    try {
        const response = await Axios.post('edit-predefine-template/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const VIEW_PREDEFINE_TEMPLATE= async (body) => {
    try {
        const response = await Axios.post('view-predefine-template/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const PREDEFINE_TEMPLATE_STATUS= async (body) => {
    try {
        const response = await Axios.post('predefine-template-status/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};
export const DELETE_PREDEFINE_TEMPLATE= async (body) => {
    try {
        const response = await Axios.post('delete-predefine-template/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const NOTIFICATION_DROPDOWN= async (body) => {
    try {
        const response = await Axios.post('list-notification-dropdown/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};
